import BackgroundContactUsSection from '@anm/components/sections/BackgroundContactUsSection';
import { FC } from 'react';

const PricingContactUsSection: FC = () => (
  <BackgroundContactUsSection
    href="mailto:support@wave.video?subject=I am interested in learning about the Enterprise plan for Wave"
    title="Need a bigger plan?"
    description="Ask us about custom options<br/>
and special pricing for Enterprise"
  />
);

export default PricingContactUsSection;
